import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormArray } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgProgressRef, NgProgress } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { PresetValidator } from 'src/app/components/pages/presets/preset-create/preset-create.validators';
import { ATTRS_VALUE_PRESENTATION_TYPES_TRANSLATE, ATTRS_VALUE_TYPES_TRANSLATE } from 'src/app/constants/preset-element-actions';
import { OPERATORS_FOR_CONDITION } from 'src/app/constants/products/products-list-actions';
import { ReferenceParams } from 'src/app/models';
import { LanguageService, NotificationService, ValidatorsService } from 'src/app/services';
import { ApiPresetsService } from 'src/app/services/api-presets.service';

@Component({
  selector: 'app-preset-add-element-actions',
  templateUrl: './preset-add-element-actions.component.html',
  styleUrls: ['./preset-add-element-actions.component.css']
})
export class PresetAddElementActionsComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  loading: boolean;
  attributes: any[] = [];
  attributeGroups: any[] = [];
  attributeValueTypes: any[] = [];
  attributePresentationTypes: any[] = [];
  references: any[] = [];
  element_id: number;
  operators: any[] = [];
  attrsValueTypesTranslate: any[] = ATTRS_VALUE_TYPES_TRANSLATE;
  attrsValuePresentationTypesTranslate: any[] = ATTRS_VALUE_PRESENTATION_TYPES_TRANSLATE;
  action:string = '';

  // Переменные для создания/изменения полей селектора
  selectedOperatorsForCondition: string = 'AND';
  operatorsForCondition = OPERATORS_FOR_CONDITION;
  condition = {
    [this.selectedOperatorsForCondition]: []
  };

  form: UntypedFormGroup = this.fb.group({
    id: [null],
    is_default: [false],
    attribute_group_id: [null, this.validator.attribute_group_id],
    attribute_id: [null, this.validator.attribute_id],
    attribute_value_type: [null, this.validator.attribute_value_type],
    attr_group_order_num: [null],
    attr_order_num: [null],
    attr_present_type_id: [null, this.validator.attr_present_type_id],
    attr_reference_id: [null],
    selectors: this.fb.array([]),
    front_field_attrs: [null],
    autocomplete_func: [null],
    attr_value_mask: [null],
    attr_value_mask_err_message: [null],
    attribute_preset_value: [null],
    attribute_preset_value_type: ['VALUE'],
    attribute_values_max_count: [null],
    mandatory: [false],
    visible: [false],
    readonly: [false],
    translation: [false]
  });

  @Input() set data(value) {

    console.log("INPUT VALUE: ", this.references.length);

    this.subscriptions.add(

      this.form.get('attr_present_type_id').valueChanges.subscribe(val => {

        this.references = [];

        if (val == 'COMBOBOX_GROUP_MULTIPLE' || val == 'COMBOBOX_GROUP' || val == 'COMBOBOX_MULTIPLE' || val == 'COMBOBOX_FILTER' || val == 'COMBOBOX') {

          this.form.get('attribute_preset_value_type').setValue('QUERY');

          this.getReferences();

        }
      })
    )

    this.action = value.action;

    if (value) {
      this.element_id = value.element_id;
    }

    if (value.element_data != null) {

      this.form.controls.id.setValue(value.element_data.id);
      this.form.controls.attr_group_order_num.setValue(value.element_data.attr_group_order_num);
      this.form.controls.attr_order_num.setValue(value.element_data.attr_order_num);
      this.form.controls.attr_present_type_id.setValue(value.element_data.attr_present_type_id);
      this.form.controls.attr_reference_id.setValue(value.element_data.attr_reference_id);
      this.form.controls.attr_value_mask.setValue(value.element_data.attr_value_mask);
      this.form.controls.attr_value_mask_err_message.setValue(value.element_data.attr_value_mask_err_message);
      this.form.controls.attribute_group_id.setValue(value.element_data.attribute_group_id);
      this.form.controls.attribute_id.setValue(value.element_data.attribute_id)
      this.form.controls.attribute_preset_value.setValue(value.element_data.attribute_preset_value)
      this.form.controls.attribute_preset_value_type.setValue(value.element_data.attribute_preset_value_type)
      this.form.controls.attribute_value_type.setValue(value.element_data.attribute_value_type)
      this.form.controls.attribute_values_max_count.setValue(value.element_data.attribute_values_max_count)
      this.form.controls.autocomplete_func.setValue(value.element_data.autocomplete_func)
      this.form.controls.is_default.setValue(value.element_data.is_default)
      this.form.controls.mandatory.setValue(value.element_data.mandatory)
      this.form.controls.readonly.setValue(value.element_data.readonly)
      this.form.controls.translation.setValue(value.element_data.translation)
      this.form.controls.visible.setValue(value.element_data.visible)

      if (value.element_data.selectors != null && Object.keys(value.element_data.selectors).length > 0) {

        for (let selector of value.element_data.selectors[this.selectedOperatorsForCondition]) {

          this.addSelectorFieldWithData(selector);

        }
      }
    }


  }

  constructor(
    public ngProgress: NgProgress,
    private fb: UntypedFormBuilder,
    private languageService: LanguageService,
    private apiPresets: ApiPresetsService,
    private notification: NotificationService,
    private validator: PresetValidator,
    private validatorService: ValidatorsService,
    public activeModal: NgbActiveModal

  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');

    this.getAttributes();
    this.getOperators();
    this.getAttributeGroup();
    this.getAttributeTypes();
    this.getAttributePresentationTypes();

    if(this.form.value.selectors.length == 0){

      this.addSelectorsFields();
    }
    

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );

  }

  ngDestroy() {
    this.subscriptions.unsubscribe();
  }


  /**
  * 
  * 
  */
  addSelectorsFields(): void {

    let control = this.form.controls.selectors as UntypedFormArray;
    control.push(this.initFilterField());
  }

  /**
   * 
   * @param i 
   */
  removeAddressField(i: number): void {

    let control = this.form.controls.selectors as UntypedFormArray;
    control.removeAt(i);
  }

  /**
  * 
  * 
  */
  initFilterField(): any {

    return this.fb.group({
      attribute_id: [null],
      operator: ['equal'],
      value: [null],
    });
  }

  /**
  * 
  * @param bankAccount any
  */
  addSelectorFieldWithData(selector: any): void {

    let control = this.form.controls.selectors as UntypedFormArray;
    control.push(this.setDataInSelectorField(selector));
  }

  /**
 * 
 * @param bankAccount any
 * @returns any
 */
  setDataInSelectorField(selector: any): any {

    return this.fb.group({
      attribute_id: [selector.attribute_id],
      operator: [selector.operator],
      value: [selector.value],

    });
  }

  /**
   * 
   */
  getAttributes(): void {

    let params: ReferenceParams = {
      ref_name: 'attributes',
      filter: {
        get: 'all'
      }
    }

    this.subscriptions.add(
      this.apiPresets.getReferences(params, params.ref_name).subscribe((response: any) => {
      
        if (response != null) {

          this.attributes = response.result;

        }
      })
    );

  }

  /**
   * 
   */
  getOperators(): void {

    let params: ReferenceParams = {
      ref_name: 'filter_conditions_operators',
      filter: {
      }
    }

    this.subscriptions.add(
      this.apiPresets.getReferences(params, params.ref_name).subscribe((response: any) => {

        if (response != null) {

          this.operators = response.result;
        }
      })
    );

  }

  /**
   * 
   */
  getAttributeGroup(): void {

    let params: ReferenceParams = {
      ref_name: 'attribute_groups',
      filter: {
      }
    }

    this.subscriptions.add(
      this.apiPresets.getReferences(params, params.ref_name).subscribe((response: any) => {

        if (response != null) {

          this.attributeGroups = response.result;
        }
      })
    );

  }

  /**
   * 
   */
  getAttributeTypes(): void {

    let params: ReferenceParams = {
      ref_name: 'attrs_value_types',
      filter: {
      }
    }

    this.subscriptions.add(
      this.apiPresets.getReferences(params, params.ref_name).subscribe((response: any) => {

        if (response != null) {

          let types: any[] = [];
          let searchData: any;

          response.result.forEach(element => {

            searchData = this.attrsValueTypesTranslate.find(val => val.id == element);

            if (searchData != null && searchData != undefined) {

              types.push(searchData);
            }

          });

          this.attributeValueTypes = types;

        }
      })
    );

  }

  /**
   * 
   */
  getAttributePresentationTypes(): void {

    let params: ReferenceParams = {
      ref_name: 'attrs_presentation_types',
      filter: {
      }
    }

    this.subscriptions.add(
      this.apiPresets.getReferences(params, params.ref_name).subscribe((response: any) => {

        if (response != null) {

          let types: any[] = [];
          let searchData: any;

          response.result.forEach(element => {

            searchData = this.attrsValuePresentationTypesTranslate.find(val => val.id == element);

            if (searchData != null && searchData != undefined) {

              types.push(searchData);
            }

          });

          this.attributePresentationTypes = types;
        }
      })
    );

  }

  /**
   * 
   */
  getReferences(): void {

    let params: ReferenceParams = {
      ref_name: 'references',
      filter: {
      }
    }

    this.subscriptions.add(
      this.apiPresets.getReferences(params, params.ref_name).subscribe((response: any) => {

        if (response != null) {

          this.references = response.result;
        }
      })
    );

  }

  /**
   * 
   * @param field 
   * @param type 
   */
  validation(field: string, type: string): boolean {

    return this.validatorService.validation(this.form.get(field), type);
  }

  /**
   * 
   */
  sendData(): void {

    let sendData = {
      element_id: this.element_id,
      element_data: this.form.value
    }

    this.selectedOperatorsForCondition == 'AND' ? this.condition = { AND: [] } : this.condition = { OR: [] };

    if (this.form.value.selectors[0].attribute_id != null) {

      for (let f of this.form.value.selectors) {

        this.condition[this.selectedOperatorsForCondition].push(f);
      }

      sendData.element_data['selectors'] = this.condition;

    } else {

      sendData.element_data['selectors'] = {};
    }

    let attribute_name = this.attributes.find(val => val.id == this.form.get('attribute_id').value);
    let attribute_group_name = this.attributeGroups.find(val => val.id == this.form.get('attribute_group_id').value);
    this.form.value['attribute_name'] = attribute_name.name;
    this.form.value['attribute_group_name'] = attribute_group_name.name;

    this.activeModal.close(sendData);
    
  }

}
